// Search functionality
export function search() {
  const button = document.querySelector('.nav-primary li.search');
  if (!button) {
    return;
  }
  const body = document.querySelector('body');
  const form = document.querySelector('.custom-search-popup form');
  button.onclick = (e) => {
    if (!body.classList.contains('search-popup')) {
      const inputSearch = form.querySelector('input[type="search"]');
      inputSearch.focus();
    }
    body.classList.toggle('search-popup');
  };
}

export function highlightSearchTerms() {
  const searchInput = document.querySelector('.search-form-input');
  if (searchInput && searchInput.value.trim() !== '') {
    const searchTerm = searchInput.value.trim();
    const regex = new RegExp(`(${searchTerm})`, 'gi');
  
    function highlightNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (regex.test(node.textContent)) {
          const frag = document.createDocumentFragment();
          let lastIndex = 0;
          node.textContent.replace(regex, (match, p1, offset) => {
            // Append text before the match
            if (offset > lastIndex) {
              frag.appendChild(document.createTextNode(node.textContent.slice(lastIndex, offset)));
            }
            // Append highlighted match
            const span = document.createElement('span');
            span.className = 'font-bold';
            span.textContent = match;
            frag.appendChild(span);
            lastIndex = offset + match.length;
          });
          // Append remaining text
          if (lastIndex < node.textContent.length) {
            frag.appendChild(document.createTextNode(node.textContent.slice(lastIndex)));
          }
          node.replaceWith(frag);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SPAN') {
        node.childNodes.forEach(highlightNode);
      }
    }
  
    const results = document.querySelectorAll('article h4, article p');
    results.forEach(el => highlightNode(el));
  }
  
  
}